import React, { Fragment, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { any } from "prop-types";

const HideBodyOverflowY = ({ children }) => {
  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, []);

  return <Fragment>{children}</Fragment>;
};

HideBodyOverflowY.propTypes = {
  history: any,
  children: any,
};

export default withRouter(HideBodyOverflowY);
